import { watch } from "@vue/composition-api";
import useAuthUser from "@/hooks/useAuthUser";

export default function useOnUserLogin(cb: () => void) {
  const { authUser } = useAuthUser();
  watch(authUser, (newVal, oldVal) => {
    if (!oldVal && newVal) {
      cb();
    }
  });
}
